import * as React from "react";
import { useEffect } from "react";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
// importing material UI components
import { useState } from "react";
import WhatsappTable from "./WhatsappTable";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import CreateTemplate from "./CreateTemplate";
import EditTemplate from "./EditTemplate/EditTemplate";
import { Box, Grid, TextField, Typography } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import Search from "@mui/icons-material/Search";
import ButtonOne from "../../common/normal-button";
import CustomTabs from "../../common/custom-tabs";
import RCSTemplatesTab from "./RCSTemplatesListTab";
import SMSTemplatesTab from "./SMSTemplatesListTab";
import { GET_RCS_BOTS } from "../../config/urls";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import typography from "../../cssUtils/typography";
import ButtonTwo from "../../common/dashboard-button";
import BackButton from "../../common/back-button";
import { confirmDiscardChanges } from "../../common/unsaved-changes";

const Whatsapp = (props) => {
  // 🟢 1. Fetch permissions FIRST so we can set the default tab state safely
  const permissionsFromStorage = JSON.parse(localStorage.getItem("permissions") || "[]");
  const hasRcsBotCreate = permissionsFromStorage.includes("rcs_bot_create.view");
  // conversations.view is granted only by WhatsApp addons, so it marks the WA channel
  const hasWa = permissionsFromStorage.includes("conversations.view");

  const [componentState, setComponent] = useState(1);
  const [templatesNamesData, setTemplatesNamesData] = useState([]);
  const [templatesData, setTemplatesData] = useState([]);
  const [templateData, setTemplateData] = useState();
  
  // 🟢 2. SMART DEFAULT TAB: If they have RCS, default to 1. Otherwise, default to 0.
  const initialTab = props?.pageParams?.activeTab !== undefined 
    ? props.pageParams.activeTab 
    : (hasWa ? 0 : hasRcsBotCreate ? 1 : 2);
    
  const [activeTab, setActiveTab] = useState(initialTab);
  
  const [bots, setBots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [openBotDialog, setOpenBotDialog] = useState(false);
  const [selectedBot, setSelectedBot] = useState(props?.pageParams?.selectedBot ? props?.pageParams?.selectedBot : "");

  useEffect(() => {
    if (props?.pageParams?.selectedBot) {
      setSelectedBot(props.pageParams.selectedBot);
    }
  }, [props?.pageParams]);

  const handleCreateTemplateClick = (newState) => {
    setComponent(newState);
  };

  // Back from create/edit: warn first if the form has unsaved changes
  const handleBackToList = () => {
    if (confirmDiscardChanges()) setComponent(1);
  };
  
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // 🟢 3. CHANNEL TABS
  // WhatsApp tab needs the WA channel, RCS tab needs the RCS channel; both show if the tenant has both.
  const allTabs = [
    { label: "WhatsApp Template", value: 0, show: hasWa },
    { label: "RCS Template", value: 1, show: hasRcsBotCreate },
    { label: "SMS Template", value: 2 }, 
  ];

  const tabs = allTabs.filter(tab => tab.show !== false);

  const createTemplateHandlers = {
    0: () => {
      handleCreateTemplateClick(2);
      props.onNavigate("create_templates");
    },
    1: () => {
      setOpenBotDialog(true);
    },
    2: () => {
      console.log("SMS create clicked");
    },
  };

  console.log("props", props);

  React.useEffect(() => {
    fetchBots();
  }, []);

  const fetchBots = async () => {
    setLoading(true);
    setError(null);
    try {
      const headers = {
        "X-Tenant-ID": localStorage.getItem("tenant") || "",
      };
      const response = await axios.get(GET_RCS_BOTS, { headers });

      // Ensure bots is always an array
      const botsData = response.data;
      if (Array.isArray(botsData)) {
        setBots(botsData);
      } else if (botsData && Array.isArray(botsData.results)) {
        // Handle paginated responses (if your API returns {results: [], count: X})
        setBots(botsData.results);
      } else if (botsData && Array.isArray(botsData.data)) {
        // Handle {data: []} format
        setBots(botsData.data);
      } else if (botsData && typeof botsData === "object") {
        // Convert object to array if needed
        setBots(Object.values(botsData));
      } else {
        // Default to empty array
        setBots([]);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch bots");
      console.error("Error fetching bots:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectBot = (botId) => {
    const selectedBotData = bots?.filter((item) => item.id === botId);
    setSelectedBot(selectedBotData[0]);
  };

  return (
    <div className="App">
      <Container maxWidth={false} sx={{ mt: 2 }}>
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 2,
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: "80%",
                "@media (max-width:1230px)": {
                  width: "100%",
                },
              }}
            >
              <CustomTabs
                value={activeTab}
                onChange={handleTabChange}
                tabs={tabs}
                sx={{ width: "100%" }}
              />
            </Box>
            <ButtonOne
              title="Create Template"
              startIcon={<AddOutlinedIcon />}
              onClick={() => {
                createTemplateHandlers[activeTab]?.();
              }}
            />
          </Box>
        </Box>
        {activeTab === 0 && (
          <Box sx={{ mt: 3}}>
            {componentState === 1 ? (
              <>
                <WhatsappTable
                  refreshkey={props.refreshKey}
                  setTemplatesNamesData={setTemplatesNamesData}
                  handleCreateTemplateClick={handleCreateTemplateClick}
                  setComponent={setComponent}
                  setTemplatesData={setTemplatesData}
                  templatesData={templatesData}
                  setTemplateData={setTemplateData}
                  templateData={templateData}
                  {...props}
                />
              </>
            ) : componentState === 2 ? (
              <>
                {/* <h2 className="heading-title">Create Template</h2> */}
                <BackButton onClick={handleBackToList} />
                <CreateTemplate
                  onNavigate={props.onNavigate}
                  templatesNamesData={templatesNamesData}
                  setComponent={setComponent}
                />
              </>
            ) : componentState === 3 ? (
              <>
                {/* <h2 className="heading-title">Edit Template</h2> */}
                <BackButton onClick={handleBackToList} />
                <EditTemplate
                  templatesNamesData={templatesNamesData}
                  setComponent={setComponent}
                  templatesData={templateData}
                />
              </>
            ) : null}
          </Box>
        )}
        {activeTab === 1 && (
          <Box>
            {componentState === 1 ? (
              <>
                <RCSTemplatesTab
                  refreshkey={props.refreshKey}
                  setTemplatesNamesData={setTemplatesNamesData}
                  handleCreateTemplateClick={handleCreateTemplateClick}
                  setComponent={setComponent}
                  setTemplatesData={setTemplatesData}
                  {...props}
                  bots={bots}
                  setBots={setBots}
                  selectedBot={selectedBot}
                />
              </>
            ) : null}
          </Box>
        )}
        {activeTab === 2 && (
          <Box>
            {componentState === 1 ? (
              <>
                <SMSTemplatesTab
                  refreshkey={props.refreshKey}
                  setTemplatesNamesData={setTemplatesNamesData}
                  handleCreateTemplateClick={handleCreateTemplateClick}
                  setComponent={setComponent}
                  setTemplatesData={setTemplatesData}
                  {...props}
                />
              </>
            ) : null}
          </Box>
        )}
      </Container>
      <Dialog
        open={openBotDialog}
        onClose={() => setOpenBotDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h6" sx={{ ...typography.h1 }}>
            Select RCS Bot
          </Typography>
        </DialogTitle>

        <DialogContent>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Select Bot</InputLabel>
            <Select
              value={selectedBot.id}
              label="Select Bot"
              onChange={(e) => handleSelectBot(e.target.value)}
            >
              {bots.map((bot) => (
                <MenuItem key={bot.id} value={bot.id}>
                  {bot.bot_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions>
          <ButtonTwo onClick={() => setOpenBotDialog(false)}>Cancel</ButtonTwo>
          <ButtonOne
            variant="contained"
            disabled={!selectedBot}
            onClick={() => {
              setOpenBotDialog(false);
              props.onNavigate("section_direct_rcs_bot_create", {
                bot: selectedBot,
                currentView: "create-template",
              });
            }}
          >
            Continue
          </ButtonOne>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default Whatsapp;
